import { message, Modal } from "antd";
import { useEffect, useState } from "react";
import { Notification } from "@/components";
import { ModelInputStyle } from "./style";
import { useSelector } from "react-redux";
import TextArea from "antd/lib/input/TextArea";

interface PropType {
  callBack: () => void;
  handleOks: (
    val:
      { value: string; value1: string; extraValue: boolean }
  ) => void;
  title: string;
  content: string[];
  msg?: string[];
  confirm?: string;
}

const App = (props: PropType) => {
  const { callBack, title, handleOks, msg, confirm, content } = props;
  const [value, setValue] = useState("0.0001");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: number,
    field: "value" | "extra",
  ) => {
    const val = e.target.value;

    if (type === 1 && field === "value") {
      if (!/^\d*\.?\d*$/.test(val)) {
        return message.error("请输入正确数字");
      }
    }

    setValue(val)
  }
  useEffect(() => {
    setPrivatekeyArr(content.join('\n'))
  }, [content])
  const handleOk = () => {
    if (!value) return Notification.Error("数量不能为空");
    handleOks({ value, value1: privatekeyArr, extraValue: isChecked });
    callBack();
  };


  const handleCancel = () => {
    callBack();
  };
  const handleOverlayClick = () => handleCancel();
  const handleModalClick = (e: React.MouseEvent) => e.stopPropagation();
  const [isChecked, setIsChecked] = useState(false);
  const [privatekeyArr, setPrivatekeyArr] = useState(``)

  return (
    <ModelInputStyle>
      <div className="custom-modal-overlay" onClick={handleOverlayClick}>
        <div className="custom-modal" onClick={handleModalClick}>
          <div className="custom-modal-header">
            <span>{title}</span>
            <button className="close-btn" onClick={handleCancel}>
              ×
            </button>
          </div>
          <div className="list">
            {msg &&
              msg.map((item, index) => (
                <div className="notice" key={index}>
                  {item}
                </div>
              ))}
          </div>

          <div className="custom-modal-body">
            报单的最小价值的阈值：
            <input
              type="text"
              value={value}
              onChange={(e) => handleChange(e, 1, "value")}
              placeholder="0.1"
              className="custom-modal-input"
              style={{
                marginRight: 10,
              }}
            />

          </div>

          <div className="custom-modal-body">
            排除地址({content.length})：
            <TextArea style={{ flex: 1 }} rows={3} value={privatekeyArr} onChange={(e) => setPrivatekeyArr(e.target.value)} placeholder="一行一个地址" />
          </div>

          {/* <div className="custom-modal-body">
            第一次用电报机器人：
            <Switch checked={isChecked} onChange={() => setIsChecked(!isChecked)}></Switch>

          </div> */}

          <div className="custom-modal-footer">
            <button className="btn btn-cancel" onClick={handleCancel}>
              取消
            </button>
            <button className="btn btn-ok" onClick={handleOk}>
              {confirm || "确定"}
            </button>
          </div>
        </div>
      </div>
    </ModelInputStyle>
  );
};

export default App;
